import React from 'react';

const RemoveIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">
        <path d="M4.10288 8.95043C4.75437 6.17301 6.92301 4.00437 9.70043 3.35288C11.7063 2.88237 13.7937 2.88237 15.7996 3.35288C18.577 4.00437 20.7456 6.17301 21.3971 8.95044C21.8676 10.9563 21.8676 13.0437 21.3971 15.0496C20.7456 17.827 18.577 19.9956 15.7996 20.6471C13.7937 21.1176 11.7063 21.1176 9.70044 20.6471C6.92301 19.9956 4.75437 17.827 4.10288 15.0496C3.63237 13.0437 3.63237 10.9563 4.10288 8.95043Z" stroke="#282A42" strokeWidth="1.5"/>
        <path d="M14.5178 13.7678L10.9822 10.2322M10.9822 13.7678L14.5178 10.2322" stroke="#282A42" strokeWidth="1.5" strokeLinecap="round"/>
    </svg>
);

export default RemoveIcon;